import { useEffect } from "react";

let notificationAudio = null;

export const initAudio = () => {

  notificationAudio = new Audio("/sounds/notification.mp3");
  notificationAudio.volume = 1;

};

export const unlockAudio = () => {

  if (!notificationAudio) return;

  notificationAudio.play()
    .then(() => {

      notificationAudio.pause();
      notificationAudio.currentTime = 0;

      console.log("Audio desbloqueado");

    })
    .catch(() => {});

};

export const playNotificationSound = () => {

  if (!notificationAudio) return;

  notificationAudio.currentTime = 0;

  notificationAudio.play().catch(err => {
    console.log("Audio bloqueado", err);
  });

};
